import { setupGA } from "./ga.js";
import { setupRouter } from "./router.js";
import { sendPageview, sendCheckout, sendAddToCart } from "./tracker.js";

// DC 公開 API
export const DC = {
  pageview: sendPageview,
  checkout: sendCheckout,
  addToCart: sendAddToCart,
};

// ------ 自動初始化流程 ------

// 1. 初始化 GA
setupGA();

// 2. 啟動 router（自動 pageview）
setupRouter();

// 3. 暴露給 window
if (typeof window !== "undefined") {
  const script = document.currentScript;
  const url = new URL(script.src);
  const providerCode = url.searchParams.get('provider_code');
  window.DC = DC;
  window.DC.providerCode = providerCode;
}

export default DC;
